<template>
  <div class="blog-side-nav-container">
    <div class="top-nav-controls">
      <NuxtLink class="top-nav-control-url" to="/new-now">
        New + Now
        <FontAwesomeIcon
          v-show="!blogHomeOnly"
          icon="fas fa-angle-right"
          class="chevron-icon"
        />
      </NuxtLink>
      <span v-show="!blogHomeOnly">
        {{ currentPageTitle }}
      </span>
    </div>

    <div class="blog-categories">
      <ul>
        <li v-for="(item, index) in blogMenuItems" :key="index">
          <nuxt-link class="blog-menu-item" :to="item.href">
            {{ item.name }}
          </nuxt-link>

          <template
            v-if="
              route.path === item.href ||
              `${item.href}/` ||
              '/category/our-brands' ||
              '/category/our-brands/' ||
              '/category/village-voices' ||
              '/category/village-voices/' ||
              (sub_menu && useLowerCase(item.name) === 'get to know')
            "
          >
            <div v-for="(sub_menu, index) in item.sub_menu" :key="index">
              <a
                v-if="sub_menu.target"
                :href="sub_menu.href"
                class="blog-menu-item sub"
                target="_blank"
              >
                <span> {{ sub_menu.name }}</span>
              </a>
              <nuxt-link
                v-else-if="sub_menu.href"
                :to="sub_menu.href"
                class="blog-menu-item sub"
                tabindex="0"
              >
                <span>{{ sub_menu.name }}</span>
              </nuxt-link>
              <nuxt-link
                v-else
                :to="sub_menu.route_name"
                class="blog-menu-item sub"
                tabindex="0"
              >
                <span>{{ sub_menu.name }}</span>
              </nuxt-link>
            </div>
          </template>
        </li>
      </ul>
    </div>

    <div class="sidebar-lookbook" v-if="lookbookImage?.url && lookbookImage.tags.includes('active')">
      <NuxtLink :to="lookbookImage.url" class="lookbook-url">
        <NuxtImg 
          class="lookbook-image"
          :src="lookbookImage.image_url + '?auto=format,compress&fm=webp'"
          :alt="lookbookImage.image_url_alt_text || sub_menu.name"
          :modifiers="{ format: 'webp' }" 
        />
      </NuxtLink>
    </div>
  </div>
</template>

<script setup>
import { NuxtLink } from "#components";
import { storeToRefs } from "pinia";
import { useRoute } from "vue-router";
import Category from "~/pages/category/[category].vue";
import { useMainStore } from "~/store/index";

const { isMobile, isTablet } = useMobileChecker();

// PROPS
const props = defineProps(["currentPageTitle", "blogHomeOnly", "category"]);

const route = useRoute();
// const config = useRuntimeConfig()
const store = useMainStore();
const { getDataSets, propertyData, property, loadPageData, api, baseURL } =
  store;
const galleries = store.galleryData ? store.galleryData : [];

/* GET DATA SETS */
const blogMenuItems = ref([]);
const dataSetsBlogMenuItems = await getDataSets({
  url: "data_sets/new-now-menu-items",
});

let sub_menu = props.category?.some(
  (el) => useLowerCase(el.name) === "get to know"
);

const lookbookImage = galleries?.find(
  (gallery) => gallery.name === "Blog Menu Images"
).gallery_items[0];

// BLOG MENU ITEMS DATA SETS
if (dataSetsBlogMenuItems && dataSetsBlogMenuItems.data) {
  blogMenuItems.value = dataSetsBlogMenuItems.data?.data_set_items[0]?.data;
} else {
  blogMenuItems.value = [];
}

watch(
  () => route.params.blog,
  async () => {
    await loadBlogPost(); // or whatever function you use to fetch blog data
  }
);
</script>

<style lang="scss" scoped>
.blog-side-nav-container {
  a {
    text-decoration: none;
    color: $black;
  }

  .top-nav-controls {
    margin: 10px 0 30px 16px;
    padding-left: 10px;

    .top-nav-control-url,
    span {
      font-family: $font_poppin_bold;
      text-transform: uppercase;
      font-size: 10px;
      line-height: 10px;
      letter-spacing: 1px;
    }

    .chevron-icon {
      height: 6px;
      font-family: $font_didot_bold;
      vertical-align: middle;
      font-weight: 900;
      margin-right: 5px;
      stroke: currentColor;
      stroke-width: 80; // MAKES BOLDER
      width: 6px;
    }
  }

  .blog-categories {
    ul {
      font-family: $font_poppin_bold;
      margin: 0 0 0 16px;
      font-size: 18px;
      line-height: 26px;
      font-weight: bold;
      text-transform: uppercase;
      letter-spacing: 1.5px;
      padding-left: 10px;
      li {
        list-style: none;
        padding-left: 0;

        .blog-menu-item.sub {
          font-family: $font_poppin_light;
          font-size: 12px;
          line-height: 21px;
          text-transform: uppercase;
          letter-spacing: 1.5px;
          margin: 0 0 0 20px;
        }
      }
    }
  }

  .sidebar-lookbook {
    .lookbook-url {
      text-decoration: none;
      border: none;
    }

    .lookbook-image {
      width: 120%;
    }
  }
}
</style>